import { jsonRequest } from '../helpers/apiRequest'
import { baseUrl } from '../helpers/baseUrl'
import Download from 'downloadjs'
import { getUrlWithQueryString } from '../helpers/util'

export async function fetchAccountsAjax() {
  return jsonRequest(`${baseUrl}/account/v4/account`, true)
}
export async function fetchAllAccountsAjax() {
  return jsonRequest(`${baseUrl}/account/v4/account/all-accounts`, true)
}

export function fetchDebitsAjax() {
  return jsonRequest(`${baseUrl}/account/v4/debit/accounts`, true)
}

export function fetchSavingsAjax() {
  return jsonRequest(`${baseUrl}/account/v4/saving/accounts`, true)
}

export function fetchCurrentsAjax() {
  return jsonRequest(`${baseUrl}/account/v4/current/accounts`, true)
}

export function fetchDebitCardsAjax() {
  return jsonRequest(`${baseUrl}/account/v4/debit/accounts/card`, true)
}

export function fetchCreditsAjax() {
  return jsonRequest(`${baseUrl}/account/v4/credit/accounts`, true)
}

export function fetchCreditCardsAjax() {
  return jsonRequest(`${baseUrl}/account/v4/credit/accounts/card`, true)
}

export function fetchDepositsAjax() {
  return jsonRequest(`${baseUrl}/deposit/v2/deposits`, true)
}

export function fetchLoansAjax() {
  return jsonRequest(`${baseUrl}/Loan/v1/loans`, true)
}

export function fetchQisaLoansAjax() {
  return jsonRequest(`${baseUrl}/Loan/v1/loans/qisa-loans`, true)
}

export function saveFriendlyName(iban, friendlyName, accountId) {
  let params = {
    iban: iban,
    friendlyName: friendlyName,
    accountId: accountId
  }
  return jsonRequest(
    `${baseUrl}/account/v4/account/property/friendlyname`,
    true,
    params,
    'PUT'
  )
}

export function setPrimary(iban, accountId) {
  let params = {
    iban: iban,
    accountId: accountId
  }
  return jsonRequest(
    `${baseUrl}/account/v4/account/property/primary`,
    true,
    params,
    'PUT',
    {
      internalServerError: true,
      badRequest: true
    }
  )
}

export function setHidden(iban, hidden, accountId) {
  let params = {
    iban: iban,
    hidden: hidden,
    accountId
  }
  return jsonRequest(
    `${baseUrl}/account/v4/account/property/hidden`,
    true,
    params,
    'PUT'
  )
}

export function fetchAccountInfo(
  iban,
  currency,
  error = { badRequest: false }
) {
  return jsonRequest(
    `${baseUrl}/transfer/v3/to-someone/receiver?Iban=${iban}&Currency=${currency}`,
    true,
    null,
    'GET',
    error
  )
}

export function fetchCardsAjax() {
  return jsonRequest(`${baseUrl}/account/v4/account/card`, true)
}
export function blockCard(cardId) {
  return jsonRequest(
    `${baseUrl}/account/v4/account/card/${cardId}/block`,
    true,
    null,
    'PUT'
  )
}
export function unblockCard(cardId, body) {
  return jsonRequest(
    `${baseUrl}/account/v4/account/card/${cardId}/unblock`,
    true,
    body,
    'PUT'
  )
}

export function fetchAccountsRestrictedAjax() {
  return jsonRequest(`${baseUrl}/account/v4/account/restricted`, true)
}

export function downloadRequisited(iban, currency, success, error) {
  if (!iban) {
    return
  }
  const targetFilename = `Account_Details_${currency}`
  const mime = 'application/pdf'
  const url = `${baseUrl}/account/v4/account/${iban}/${currency}/requisites/pdf`
  jsonRequest(url, true)
    .then(res => {
      res
        .blob()
        .then(blb => {
          Download(blb, targetFilename, mime)
          if (success) success()
        })
        .catch(() => {
          if (error) error()
        })
    })
    .catch(() => error())
}

export const setCurrencyPriority = (iban, accountCurrencies) => {
  return jsonRequest(
    `${baseUrl}/account/v4/account/SetAccountCurrencyPriorities`,
    true,
    { iban, accountCurrencies },
    'PUT'
  )
}

export async function fetchP2pCardsAjax() {
  return jsonRequest(`${baseUrl}/account/v2/p2p/card`, true)
}

export function setP2pCardFriendlyName(id, friendlyName) {
  return jsonRequest(
    `${baseUrl}/account/v2/p2p/card/friendly-name`,
    true,
    { id, friendlyName },
    'PUT'
  )
}

export function setP2pCardFavorite(id) {
  return jsonRequest(
    `${baseUrl}/account/v2/p2p/card/favorite`,
    true,
    { id },
    'PUT'
  )
}

export function deleteP2pCard(id) {
  return jsonRequest(`${baseUrl}/account/v2/p2p/card`, true, { id }, 'DELETE')
}

export function createP2pCardOrder() {
  return jsonRequest(
    `${baseUrl}/account/v2/p2p/card/create-order`,
    true,
    null,
    'POST'
  )
}
export function createP2pCardOrderTemp() {
  return jsonRequest(
    `${baseUrl}/account/v2/p2p/card/create-order/temporary`,
    true,
    null,
    'POST'
  )
}
export function getTransferMatrixAjax() {
  return jsonRequest(
    `${baseUrl}/account/v4/account/service/matrix`,
    true,
    null,
    'GET'
  )
}
export function fetchP2pTempCard(orderId) {
  return jsonRequest(
    `${baseUrl}/account/v2/p2p/card/temporary/${orderId}`,
    true,
    null,
    'GET'
  )
}

export async function fetchP2pNewCardsAjax(orderId) {
  return jsonRequest(`${baseUrl}/account/v2/p2p/card/${orderId}`, true)
}

export async function fetchP2PSaveNewCardAjax(orderId) {
  return jsonRequest(
    `${baseUrl}/account/v2/p2p/card/save/${orderId}`,
    true,
    null,
    'POST'
  )
}
export function fetchP2PCardBanksAjax() {
  return jsonRequest(`${baseUrl}/account/v2/p2p/card/banks`, true)
}

export function updateP2PCardBankAjax({ p2PCardId, bankId }) {
  return jsonRequest(
    `${baseUrl}/account/v2/p2p/card/bank`,
    true,
    { p2PCardId, bankId },
    'PUT'
  )
}

export function checkP2PCardAddLimit() {
  return jsonRequest(`${baseUrl}/account/v2/p2p/card/check-limit`, true)
}

export function fetchP2pCardsTrnsferLimitsAjax() {
  return jsonRequest(`${baseUrl}/transfer/v2/p2p/configuration`, true)
}

// card restriction functions
export function sendTwoFactorCode(sessionId = null) {
  return jsonRequest(
    `${baseUrl}/account/v4/debit/sendTwoFactor`,
    true,
    { sessionId },
    'POST'
  )
}
export function submitCardRestriction(data) {
  return jsonRequest(
    `${baseUrl}/account/v4/debit/changeRiskCategory`,
    true,
    data,
    'POST'
  )
}

// reset pin for cards
export function sendTwoFactor(data) {
  return jsonRequest(
    `${baseUrl}/account/v4/account/send-two-factor`,
    true,
    data,
    'POST'
  )
}

export function resetPin(data) {
  return jsonRequest(
    `${baseUrl}/account/v4/account/reset-pin`,
    true,
    data,
    'PUT'
  )
}

export function downloadSavingsDetailsPdf(id, fileName = 'Important Terms') {
  return jsonRequest(
    `${baseUrl}/account/v4/saving/details/${id}/pdf`,
    true
  ).then(res =>
    res.blob().then(blb => {
      return Download(blb, fileName, 'application/pdf')
    })
  )
}

export function downloadDebitDetailsPdf(iban, fileName = 'Important Terms') {
  return jsonRequest(
    `${baseUrl}/account/v4/debit/details/${iban}/pdf`,
    true
  ).then(res =>
    res.blob().then(blb => {
      return Download(blb, fileName, 'application/pdf')
    })
  )
}

export function downloadCreditDetailsPdf(id, fileName = 'Important Terms') {
  return jsonRequest(
    `${baseUrl}/account/v4/credit/details/${id}/pdf`,
    true
  ).then(res =>
    res.blob().then(blb => {
      return Download(blb, fileName, 'application/pdf')
    })
  )
}

/**
 * ProductPrice related to additional bank services
 */

export async function fetchProductPricePackagesAjax(params = {}) {
  let url = getUrlWithQueryString(
    `${baseUrl}/account/v1/product-price/package`,
    params
  )
  return jsonRequest(url, true)
}

export async function fetchProductInsurancesAjax() {
  return jsonRequest(`${baseUrl}/account/v1/product-price/insurance`, true)
}

export function fetchStudioPackageAgreementPdf() {
  return jsonRequest(
    `${baseUrl}/account/v1/cardpackage/CurrentStudioAgreement/pdf`,
    true,
    {},
    'POST'
  )
    .then(res => {
      return res
        .blob()
        .then(blb => {
          return Download(blb, 'agreement', 'application/pdf')
        })
        .catch(() => {})
    })
    .catch(() => {})
}

export function fetchStudioPackageAgreementForOnboardingPdf() {
  return jsonRequest(
    `${baseUrl}/account/v1/product-price/CurrentStudioAgreementForOnboarding/pdf`,
    true
  )
    .then(pdfUrl => {
      const link = document.createElement('a')
      link.href = pdfUrl
      link.download = 'agreement.pdf'
      link.target = '_blank'
      link.rel = 'noopener noreferrer'

      document.body.appendChild(link)

      link.click()
      document.body.removeChild(link)
    })
    .catch(() => {})
}

export async function fetchProductPriceSmsAjax(params = {}) {
  let url = getUrlWithQueryString(
    `${baseUrl}/account/v1/product-price/sms`,
    params
  )
  return jsonRequest(url, true)
}

export async function fetchAutoComfortPaymentsAjax(params = {}) {
  let url = getUrlWithQueryString(
    `${baseUrl}/account/v1/product-price/AutoComfortPayments`,
    params
  )
  return jsonRequest(url, true)
}

export function fetchJuniorAccountsAjax() {
  return jsonRequest(`${baseUrl}/account/v4/debit/junior-accounts`, true)
}
export function fetchJuniorAccountListAjax() {
  return jsonRequest(`${baseUrl}/account/v4/account/junior-accounts`, true)
}
export function fetchJuniorAccountLimitsAjax(
  params = { cardId: null, personalNumber: null }
) {
  let url = getUrlWithQueryString(`${baseUrl}/account/v1/junior/limit`, params)
  return jsonRequest(url, true)
}

export function saveJuniorAccountFriendlyName({
  iban,
  accountId,
  ownerPersonId,
  friendlyName
}) {
  return jsonRequest(
    `${baseUrl}/account/v1/junior/property/friendlyname`,
    true,
    {
      iban,
      accountId,
      ownerPersonId,
      friendlyName
    },
    'PUT'
  )
}

export function downloadJuniorAccountRequisited({
  iban,
  currency,
  personalId,
  success,
  error
}) {
  if (!iban) {
    return
  }
  const targetFilename = `Account_Details_${currency}`
  const mime = 'application/pdf'
  const url = `${baseUrl}/account/v1/junior/${iban}/${currency}/requisites/pdf?personalId=${personalId}`
  jsonRequest(url, true)
    .then(res => {
      res
        .blob()
        .then(blb => {
          Download(blb, targetFilename, mime)
          if (success) success()
        })
        .catch(() => {
          if (error) error()
        })
    })
    .catch(() => {
      if (error) error()
    })
}

export function juniorAccountCreateSession({ cardId, cardHolderPersonalId }) {
  return jsonRequest(
    `${baseUrl}/account/v1/junior/card/create-session`,
    true,
    {
      cardId,
      cardHolderPersonalId
    },
    'POST'
  )
}

export function juniorAccountSession(params = {}) {
  const { sessionId = null, type = 6 } = params
  return jsonRequest(
    `${baseUrl}/account/v1/junior/send-two-factor`,
    true,
    {
      sessionId,
      type
    },
    'POST'
  )
}

export function juniorAccountSaveLimit(params = {}) {
  const {
    limitId,
    cardId,
    cardHolderPersonalId,
    sessionId,
    otp,
    validationId
  } = params
  return jsonRequest(
    `${baseUrl}/account/v1/junior/limit`,
    true,
    {
      limitId,
      cardId,
      cardHolderPersonalId,
      sessionId,
      otp,
      validationId
    },
    'PUT'
  )
}
export function juniorAccountResetPin(params = {}) {
  const { cardId, cardHolderPersonalId, sessionId, otp, validationId } = params
  return jsonRequest(
    `${baseUrl}/account/v1/junior/reset-pin`,
    true,
    {
      cardId,
      cardHolderPersonalId,
      sessionId,
      otp,
      validationId
    },
    'PUT'
  )
}

export function juniorAccountBlockCard(params = {}) {
  const { cardId, ...props } = params

  let url = getUrlWithQueryString(
    `${baseUrl}/account/v1/junior/card/${cardId}/block`,
    props
  )

  return jsonRequest(url, true, {}, 'PUT')
}

export function juniorAccountUnblockCard(params = {}) {
  const { cardId, personalId = null, ...props } = params

  let url = getUrlWithQueryString(
    `${baseUrl}/account/v1/junior/card/${cardId}/unblock`,
    { personalId }
  )
  return jsonRequest(url, true, props, 'PUT')
}

export function startFetchJuniorCardDetails({
  cardId,
  cardHolderPersonalId
} = {}) {
  return jsonRequest(
    `${baseUrl}/account/v1/junior/card/create-session`,
    true,
    {
      cardId,
      cardHolderPersonalId
    },
    'POST',
    {
      internalServerError: false,
      badRequest: false
    }
  )
}

export function fetchJuniorAccountLimitDetailAjax(params = { cardId: null }) {
  let url = getUrlWithQueryString(
    `${baseUrl}/account/v1/junior/${params.cardId}/limit-status`,
    params
  )
  return jsonRequest(url, true)
}
